import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import SectionHeading from "@/components/feature/SectionHeading";
import MovieCard from "@/components/feature/MovieCard";
import usePageMeta from "@/hooks/usePageMeta";
import { allMovies } from "@/lib/movies";
import HeroCarousel from "./components/HeroCarousel";
import CategoryShortcuts from "./components/CategoryShortcuts";
import LatestList from "./components/LatestList";
import SidebarPanel from "./components/SidebarPanel";
import IntroBand from "./components/IntroBand";

const HOME_TITLE = "淫乱小镇影视作品介绍与剧情分享";
const HOME_DESCRIPTION =
  "淫乱小镇为您提供详细的影视作品剧情介绍和分析，涵盖相关剧集和电影资源，帮助您更好了解作品内容和背景。";
const HOME_KEYWORDS = "淫乱小镇,影视作品,剧情介绍,影视分析,影视内容,剧集推荐";

export default function Home() {
  usePageMeta(HOME_TITLE, HOME_DESCRIPTION, HOME_KEYWORDS);

  const latest = [...allMovies]
    .sort((a, b) => b.addedAt.localeCompare(a.addedAt))
    .slice(0, 6);

  const topRated = [...allMovies].sort((a, b) => b.rating - a.rating).slice(0, 3);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />

      <main>
        <HeroCarousel />
        <CategoryShortcuts />

        <section className="max-w-shell mx-auto px-4 md:px-8 mt-12 md:mt-16">
          <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-9 lg:gap-10">
            <div className="min-w-0">
              <SectionHeading
                eyebrow="Latest Updates"
                title="最新影视作品"
                description="按收录时间排序的新作与经典，每一条都附有完整的剧情摘要与解析入口。"
                linkTo="/category?sort=added"
                linkLabel="查看全部作品"
              />
              <LatestList movies={latest} />

              <div className="mt-12 md:mt-14">
                <SectionHeading
                  eyebrow="Editor's Picks"
                  title="编辑精选 · 值得细看"
                  description="口碑与叙事完成度兼具的三部作品，适合作为入门。"
                  linkTo="/category?sort=rating"
                  linkLabel="按评分浏览"
                />
                <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                  {topRated.map((movie) => (
                    <MovieCard key={movie.id} movie={movie} showSummary={false} />
                  ))}
                </div>
              </div>
            </div>

            <SidebarPanel />
          </div>
        </section>

        <IntroBand />
      </main>

      <SiteFooter />
    </div>
  );
}